import React from "react"

import type { QuoteFieldsFragment } from "~graphql/generated/graphql"
import CheckoutSummaryPackage from "~components/pages/listing/checkout/checkout-summary-package"

interface Props {
    readonly quote: QuoteFieldsFragment
}

export default function CheckoutSummaryPackages({ quote }: Props) {
    return (
        <div>
            {quote.packages.map((quotePackage) => (
                <CheckoutSummaryPackage
                    key={quotePackage.id}
                    addOns={quotePackage.add_ons}
                    pricingPackage={quotePackage.pricing_package}
                    numberOfGuests={quotePackage.number_of_guests}
                />
            ))}
        </div>
    )
}
